/* global PRODUCTION */

// ui
import ui from "./ui";

// dependencies
import { push } from "yarrr";
import { GenerateProcess } from "redux-process";

// actions
import { updateUI } from "Actions/ui";
import { setupAuthenticatedEnvironment } from "Actions/authentication";

// selectors
import { getPageName } from "Selectors/ui";
import { getEmail, getPassword } from "./selectors";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

export const inputChange = (name, value) => (dispatch) => {
	dispatch(changeUI([name], value));
};

export const authenticate = () => async (dispatch, getState) => {
	const state = getState();
	const email = getEmail(state);
	const password = getPassword(state);

	const request = await dispatch(
		GenerateProcess("Authenticate", {
			payload: {
				email,
				password,
			},
		})
	);
	// Check didMFALoginPass property to see if browser should
	// reroute to mfa-login.
	// Password and Email also has to be valid to move onto mfa-login
	if (!request.response.didMfaLoginPass && request.response.isValid) {
		dispatch(push("/mfa-login"));
	}

	// If MFA login passed and email password is valid,
	// Let them into Logan
	else if (request.response.isValid) {
		dispatch(setupAuthenticatedEnvironment());
		dispatch(push("/"));
	}
};

export const authenticateGoogle = () => async (dispatch) => {
	const auth = await dispatch(
		GenerateProcess("AuthenticateGoogle", {
			payload: {},
		})
	);

	if (auth.response && auth.response.authUrl) {
		window.location.href = auth.response.authUrl;
	} else {
		console.error("Authentication with Google failed: ", auth.response);
	}
};

export const authenticateGoogleCallback = (code) => async (dispatch) => {
	const request = await dispatch(
		GenerateProcess("AuthenticateGoogleCallback", {
			payload: {
				code,
			},
		})
	);

	if (request.response && request.response.isValid) {
		dispatch(setupAuthenticatedEnvironment());
		dispatch(push("/"));
	}
};

export const init = () => (dispatch) => {
	const initialUI = ui;

	dispatch(changeUI([], initialUI));
};
